import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { TranslationLookupModule } from '@main-client/src/app/pipes/translation-lookup/translation-lookup.module';

import { AccountEditDrawerService } from '@main-client/src/app/account-edit-drawer/account-edit-drawer.service';

import { MatchExclusionsDisplayComponent } from './match-exclusions-display.component';

@NgModule({
  declarations: [MatchExclusionsDisplayComponent],
  exports: [MatchExclusionsDisplayComponent],
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatIconModule,
    TranslationLookupModule,
  ],
  providers: [AccountEditDrawerService],
})
export class MatchExclusionsDisplayModule {}
